import { graphql } from "gql.tada";

const ImageFragment = graphql(`
  fragment ImageFragment on Image {
    id
    url
    originalWidth
    originalHeight
  }
`);

export default ImageFragment;
